import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Moment from 'react-moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Chip from '@material-ui/core/Chip';

import API from '../api/ApiTool';
import Loading from '../components/Loading';
import { mid } from '../theme';

const STATUS_COLORS = {
  subscribed:       mid.green,
  pending:          mid.amber,
  'not-subscribed': mid.border,
};

const styles = {
  page: {
    backgroundColor: mid.bg0,
    minHeight: '100vh',
    padding: '0',
  },
  header: {
    backgroundColor: mid.bg1,
    borderBottom: `1px solid ${mid.border}`,
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  title: {
    fontSize: '16px',
    fontWeight: 600,
    color: mid.text0,
    letterSpacing: '-0.01em',
    fontFamily: 'inherit',
  },
  dateNav: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
  dateBtn: {
    background: 'none',
    border: `1px solid ${mid.border}`,
    color: mid.blue,
    cursor: 'pointer',
    padding: '4px 12px',
    borderRadius: '6px',
    fontSize: '13px',
    fontFamily: 'inherit',
    transition: 'border-color 0.15s ease, background 0.15s ease',
  },
  dateDisplay: {
    color: mid.text0,
    fontSize: '13px',
    minWidth: '110px',
    textAlign: 'center',
  },
  dateInput: {
    background: mid.bg2,
    border: `1px solid ${mid.border}`,
    color: mid.text0,
    padding: '4px 8px',
    borderRadius: '6px',
    fontSize: '12px',
    fontFamily: 'inherit',
    cursor: 'pointer',
  },
  summaryBar: {
    padding: '10px 24px',
    borderBottom: `1px solid ${mid.border}`,
    display: 'flex',
    gap: '24px',
    backgroundColor: mid.bg1,
  },
  summaryItem: {
    fontSize: '12px',
    color: mid.text1,
  },
  summaryValue: {
    color: mid.cyan,
    fontWeight: 600,
    marginRight: '4px',
  },
  companyRow: {
    cursor: 'pointer',
    backgroundColor: mid.bg1,
  },
  companyName: {
    color: mid.blue,
    cursor: 'pointer',
    fontWeight: 500,
  },
  expandedSection: {
    backgroundColor: mid.bg0,
    padding: '0 0 0 48px',
  },
  subHeader: {
    fontSize: '10px',
    color: mid.text1,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    padding: '8px 16px 4px',
  },
  callRow: {
    fontSize: '11px',
    color: mid.text1,
    padding: '3px 16px',
    display: 'flex',
    gap: '16px',
  },
  callNumber: {
    color: mid.cyan,
    minWidth: '140px',
  },
  callDuration: {
    color: mid.text1,
    minWidth: '70px',
  },
  callTime: {
    color: mid.text2,
  },
  empty: {
    padding: '48px',
    textAlign: 'center',
    color: mid.text2,
    fontSize: '13px',
  },
};

function statusChip(status) {
  return (
    <Chip
      label={status}
      style={{
        height: '20px',
        fontSize: '10px',
        backgroundColor: STATUS_COLORS[status] || mid.border,
        color: mid.bg0,
      }}
    />
  );
}

function formatDuration(seconds) {
  if (!seconds) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m + ':' + String(s).padStart(2, '0');
}

function addDays(dateStr, n) {
  const d = new Date(dateStr + 'T12:00:00');
  d.setDate(d.getDate() + n);
  return d.toISOString().slice(0, 10);
}

function today() {
  return new Date().toISOString().slice(0, 10);
}

class CompanyRow extends Component {
  state = { open: false };

  render() {
    const { company, onCompanyClick } = this.props;
    const { open } = this.state;

    const thisYear = new Date().getFullYear();
    const lastPaidYear = company.last_paid ? new Date(company.last_paid).getFullYear() : null;
    const billingStale = !company.last_paid || lastPaidYear < thisYear;
    const staleBorder = `3px solid ${mid.amber}`;

    return (
      <React.Fragment>
        <TableRow
          style={{
            ...styles.companyRow,
            ...(billingStale ? { backgroundColor: 'rgba(245,158,11,0.22)', borderLeft: staleBorder } : {}),
          }}
          onClick={() => this.setState({ open: !open })}
        >
          <TableCell style={{ width: '24px', padding: '0 4px 0 8px', borderBottom: `1px solid ${mid.border}` }}>
            <span style={{ color: billingStale ? mid.amber : mid.text2, fontSize: '10px' }}>{open ? '▼' : '▶'}</span>
          </TableCell>
          <TableCell style={{ borderBottom: `1px solid ${mid.border}` }}>
            <span
              style={{ ...styles.companyName, ...(billingStale ? { color: mid.amber } : {}) }}
              onClick={(e) => { e.stopPropagation(); onCompanyClick(company.company_id); }}
            >
              {company.company_name || '—'}
            </span>
          </TableCell>
          <TableCell style={{ borderBottom: `1px solid ${mid.border}` }}>
            {statusChip(company.status)}
          </TableCell>
          <TableCell style={{ borderBottom: `1px solid ${mid.border}`, color: billingStale ? mid.amber : (company.tariff ? mid.text0 : mid.text2) }}>
            {company.tariff || 'no plan'}
          </TableCell>
          <TableCell style={{ borderBottom: `1px solid ${mid.border}`, fontSize: '11px',
            color: billingStale ? mid.amber : mid.text1,
            fontWeight: billingStale ? 700 : 'normal',
          }}>
            {company.last_paid
              ? <Moment format="YYYY-MM-DD">{company.last_paid}</Moment>
              : 'never'
            }
            {billingStale && <span style={{ marginLeft: '6px', fontSize: '9px', letterSpacing: '0.05em' }}>⚠</span>}
          </TableCell>
          <TableCell style={{ borderBottom: `1px solid ${mid.border}`, color: billingStale ? mid.amber : mid.cyan, textAlign: 'right' }}>
            {company.total_calls}
          </TableCell>
          <TableCell style={{ borderBottom: `1px solid ${mid.border}`, color: billingStale ? mid.amber : mid.text1, textAlign: 'right' }}>
            {company.total_minutes} min
          </TableCell>
          <TableCell style={{ borderBottom: `1px solid ${mid.border}`, color: billingStale ? mid.amber : mid.text1, fontSize: '11px' }}>
            {company.owner_email || '—'}
          </TableCell>
        </TableRow>

        {open && (
          <TableRow style={{ backgroundColor: mid.bg0 }}>
            <TableCell colSpan={8} style={{ padding: 0, borderBottom: `1px solid ${mid.border}` }}>
              <div style={styles.expandedSection}>
                {company.bridges.map(bridge => (
                  <div key={bridge.bridge_id} style={{ paddingBottom: '8px' }}>
                    <div style={styles.subHeader}>
                      {bridge.phone_number || 'bridge ' + bridge.bridge_id}
                      &nbsp;&nbsp;
                      <span style={{ color: mid.cyan }}>{bridge.call_count} calls</span>
                      &nbsp;·&nbsp;
                      <span style={{ color: mid.text1 }}>{bridge.minutes} min</span>
                    </div>
                    {bridge.calls.map((call, i) => (
                      <div key={i} style={styles.callRow}>
                        <span style={styles.callNumber}>{call.caller_number || 'unknown'}</span>
                        <span style={styles.callDuration}>{formatDuration(call.duration)}</span>
                        <span style={styles.callTime}>
                          {call.created
                            ? <Moment format="HH:mm:ss">{call.created}</Moment>
                            : '—'
                          }
                        </span>
                        {call.direction && (
                          <span style={{ color: mid.text2 }}>{call.direction}</span>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            </TableCell>
          </TableRow>
        )}
      </React.Fragment>
    );
  }
}

class SubscriberActivityByDay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: today(),
      data: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.fetchData(this.state.date);
  }

  fetchData(date) {
    this.setState({ loading: true, data: null });
    API.GET('/bridges/subscriber-activity/?date=' + date)
      .then(r => r.json())
      .then(data => this.setState({ data, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  changeDate(n) {
    const next = addDays(this.state.date, n);
    this.setState({ date: next });
    this.fetchData(next);
  }

  handleDateInput(e) {
    const val = e.target.value;
    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
      this.setState({ date: val });
      this.fetchData(val);
    }
  }

  goToCompany(id) {
    this.props.history.push('/company-detail/' + id);
  }

  render() {
    const { date, data, loading } = this.state;
    const isToday = date === today();

    const totalCalls = data ? data.companies.reduce((s, c) => s + c.total_calls, 0) : 0;
    const totalMinutes = data ? data.companies.reduce((s, c) => s + c.total_minutes, 0).toFixed(1) : 0;

    return (
      <div style={styles.page}>
        <div style={styles.header}>
          <span style={styles.title}>Subscriber Activity by Day</span>
          <div style={styles.dateNav}>
            <button style={styles.dateBtn} onClick={() => this.changeDate(-1)}>◀ prev</button>
            <span style={styles.dateDisplay}>{date}</span>
            <button
              style={{ ...styles.dateBtn, opacity: isToday ? 0.3 : 1 }}
              onClick={() => !isToday && this.changeDate(1)}
              disabled={isToday}
            >
              next ▶
            </button>
            <input
              type="date"
              style={styles.dateInput}
              value={date}
              max={today()}
              onChange={(e) => this.handleDateInput(e)}
            />
          </div>
        </div>

        {data && (
          <div style={styles.summaryBar}>
            <span style={styles.summaryItem}>
              <span style={styles.summaryValue}>{data.total_companies}</span>
              companies active
            </span>
            <span style={styles.summaryItem}>
              <span style={styles.summaryValue}>{totalCalls}</span>
              calls
            </span>
            <span style={styles.summaryItem}>
              <span style={styles.summaryValue}>{totalMinutes}</span>
              min
            </span>
          </div>
        )}

        {loading && <Loading />}

        {!loading && data && data.companies.length === 0 && (
          <div style={styles.empty}>No subscriber activity found for {date}.</div>
        )}

        {!loading && data && data.companies.length > 0 && (
          <Table>
            <TableHead>
              <TableRow style={{ backgroundColor: mid.bg2 }}>
                <TableCell style={{ width: '24px' }} />
                <TableCell>Company</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Plan</TableCell>
                <TableCell>Last Paid</TableCell>
                <TableCell style={{ textAlign: 'right' }}>Calls</TableCell>
                <TableCell style={{ textAlign: 'right' }}>Minutes</TableCell>
                <TableCell>Owner</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.companies.map(company => (
                <CompanyRow
                  key={company.company_id}
                  company={company}
                  onCompanyClick={(id) => this.goToCompany(id)}
                />
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    );
  }
}

export default withRouter(SubscriberActivityByDay);



// WEBPACK FOOTER //
// ./src/pages/SubscriberActivityByDay.js